<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Notification Queue</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content">
  <section class="filters">
    <app-filters
      class="filter-component"
      #filtersComponent
      sectionTitle="Rides"
      [filters]="inputs"
      [filterActionsPlacement]="'end'"
      [AllowUpdateFilterControls]="true"
      (applyFilters)="search($event)"
      (filtersClear)="search($event)"
      [filterToggleIcon]="'icon-funnel-simple'">
    </app-filters>
  </section>

  @if (notificationQueue().length > 0) {
    <p-table
      #table
      [value]="notificationQueue()"
      [columns]="columns"
      dataKey="id"
      [rows]="rows"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [loading]="loading"
      [paginator]="true"
      [(first)]="first"
      [totalRecords]="totalRecords"
      (onPage)="onPage($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [scrollable]="true"
      [tableStyleClass]="'table-main-mode border-round-lg'"
      appendTo="body">
      <ng-template
        #header
        let-columns>
        <tr>
          <th
            class="index Utilities-Uppercase-sm-semi text-primary-color"
            scope="col"
            style="min-width: 60px">
            #
          </th>
          @for (col of columns; track col) {
            <th
              [class]="'Utilities-Uppercase-sm-semi text-primary-color ' + col.field"
              scope="col">
              <span>{{ col.name }}</span>
            </th>
          }
          <th
            class="actions Utilities-Uppercase-sm-semi text-primary-color"
            scope="col"
            style="min-width: 44px"></th>
        </tr>
      </ng-template>
      <ng-template
        #body
        let-rowData
        let-columns="columns"
        let-index="rowIndex">
        <tr>
          <td
            class="index"
            style="min-width: 60px">
            {{ index + 1 }}
          </td>
          @for (col of columns; track col) {
            <td>
              @if (col.field == "Title") {
                <span class="title label-large-regular text-primary-color">{{ rowData[col.field] }}</span>
              } @else {
                <!-- There is currently only status left -->
                <div class="flex flex-column gap-spacing-3xs">
                  <app-tag
                    class="ride-status-tag-sm"
                    styleClass="bold"
                    [content]="rowData[col.field]?.title"
                    sizeClass="tag-sm"
                    [severityClass]="rowData[col.field]?.severity">
                  </app-tag>
                  <span class="date-time label-large-regular text-light-color">{{ rowData["DueDate"] | date: "MMM d, y" }}, {{ rowData["DueTime"] | timeFormat }}</span>
                </div>
              }
            </td>
          }
          <td
            class="actions"
            style="min-width: 44px">
            <div>
              <p-menu
                #menuRef
                [appendTo]="'body'"
                [model]="menuItems()"
                [popup]="true" />
              <app-button
                (btnClick)="setMenu($event, rowData, menuRef)"
                [iconOnlyButton]="true"
                icon="icon-dots-three-vertical"
                sizeClass="p-button-sm"
                severity="primary"
                [textButton]="true"></app-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <app-no-records></app-no-records>
  }
</div>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
</div>
